export const range6m1yAll = {
  buttons: [
    {
      type: 'month',
      count: 6,
      text: '6m',
    },
    {
      type: 'year',
      count: 1,
      text: '1y',
    },
    {
      type: 'all',
      text: 'All',
    },
  ],
}

export const range6m1y5y20yAll = {
  selected: 3,
  buttons: [
    { type: 'month', count: 6, text: '6m' },
    { type: 'year', count: 1, text: '1y' },
    { type: 'year', count: 5, text: '5y' },
    { type: 'year', count: 20, text: '20y' },
    { type: 'all', text: 'All' },
  ],
}

export const defaultMinMaxIndicators = (series: any[]) =>
  series.map((s: any) => ({
    id: `default-minmax-${s.id}`,
    name: `${s.name} - Default MinMax`,
    type: 'label',
    targetId: s.id,
    steps: [{ subtype: 'minmax' }],
  }))

export const defaultMSDIndicators = (
  series: any[],
  options: { avg: boolean; sd1: boolean; sd2: boolean }
) =>
  series.map((s: any) => ({
    id: `default-msd-${s.id}`,
    name: `${s.name} - Default MSD`,
    type: 'plotline',
    targetId: s.id,
    steps: [
      {
        subtype: 'msd',
        options,
      },
    ],
  }))
